import React, { useEffect } from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { ATIKXZIO_SITE_URL } from "../lib/constants";
import { useLang } from "../lib/i18n";

const STR = {
  en: { title: "Atikxzio HMS now lives on its own site", cont: "Continue to Atikxzio HMS" },
  hi: { title: "Atikxzio HMS अब अपनी वेबसाइट पर है", cont: "Atikxzio HMS पर जाएँ" },
};

/* /products/atikxzio-hms is retired. The no-JS version is generated by scripts/hms-redirect.js. */
export default function AtikxzioRedirect() {
  const { lang } = useLang();
  const s = STR[lang];

  useEffect(() => {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", ATIKXZIO_SITE_URL);
    document.title = "Atikxzio HMS — hospital management system";

    try {
      window.top.location.replace(ATIKXZIO_SITE_URL);
    } catch {
      window.location.replace(ATIKXZIO_SITE_URL);
    }
  }, []);

  return (
    <section className="flex min-h-[70vh] items-center bg-navy" data-testid="hms-redirect">
      <div className="mx-auto max-w-[1200px] px-5 py-32 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-electric-light">Atikxzio HMS</p>
        <h1 className="mt-4 max-w-2xl font-display text-[2rem] font-black leading-tight tracking-tight text-white lg:text-[2.75rem]">{s.title}</h1>
        <a
          href={ATIKXZIO_SITE_URL}
          target="_top"
          rel="noopener"
          className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-navy"
          data-testid="hms-redirect-continue"
        >
          {s.cont} <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
        </a>
      </div>
    </section>
  );
}
